import { render, staticRenderFns } from "./OrderPaymentInfo.vue?vue&type=template&id=13928fcc&"
import script from "./OrderPaymentInfo.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports